var map = {
	"./ArticlesWidget.vue": "6e4d",
	"./BaseWidgetForm.vue": "306b",
	"./CategoriesWidget.vue": "3f6e",
	"./ContactWidget.vue": "cdfd",
	"./FaqWidget.vue": "f0f5",
	"./GalleryWidget.vue": "c474",
	"./ImageWidget.vue": "a62d",
	"./JuryAccordionWidget.vue": "6d3c",
	"./JuryWidget.vue": "5c9c",
	"./LinkWidget.vue": "41c9",
	"./LogotypesWidget.vue": "45d3",
	"./NewsletterWidget.vue": "d8f8",
	"./PeopleListWidget.vue": "108b",
	"./PersonWidget.vue": "205b",
	"./RelatedArticlesWidget.vue": "f539",
	"./ScheduleAndPricesWidget.vue": "86892",
	"./SliderWidget.vue": "1d41",
	"./SocialWidget.vue": "3c2b",
	"./TextWidget.vue": "ce64",
	"./TextWithHeaderWidget.vue": "a6be",
	"./TextWithLinksWidget.vue": "4aaf",
	"./TwoColumnListWidget.vue": "c859",
	"./TwoColumnsHeaderWidget.vue": "1381",
	"./TwoColumnsWidget.vue": "eac5",
	"./VideoWidget.vue": "733b",
	"./VideosWidget.vue": "3c5c",
	"./WrapperWidget.vue": "ae59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f7e1";